export const CATEGORIES_DISPLAY_LIMIT = 25;
export const CategoryIconSize = '20px';
export const CategoryActionButtons = {
  button: {
    width: '30px',
    height: '30px',
  },
  icon: '20px',
};
